export default "__VITE_ASSET__6e7e64b8__"